function $bebe1cbb5a309c8c$export$44487a86467333c3() {
    return {
        "backend-url": "https://api.genomicscore.be",
        "services-url": "https://services.genomicscore.be"
    };
}


var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(f) {
                                    return n(r, t, e, u, a, i, f);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, f) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, f) : n(r)(t)(e)(u)(a)(i)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, c(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = i(n, r, 0, e); u && (t = e.pop()); u = i(t.a, t.b, 0, e));
        return u;
    }
    function i(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (t > 100) return e.push(c(n, r)), !0;
        for(var a in 0 > n.$ && (n = Nr(n), r = Nr(r)), n)if (!i(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    function f(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = f(n.a, r.a)) || (t = f(n.b, r.b)) ? t : f(n.c, r.c);
        for(; n.b && r.b && !(t = f(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var o = F2(function(n, r) {
        var t = f(n, r);
        return 0 > t ? Tr : t ? Er : _r;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function v(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function s(n) {
        return n;
    }
    function b(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = $(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = $(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function $(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2($);
    function g(n) {
        for(var r = l, t = n.length; t--;)r = $(n[t], r);
        return r;
    }
    function p(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var m = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return g(e);
    }), w = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? u(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), y = Math.ceil, R = Math.floor, A = Math.round, j = Math.log, k = F2(function(n, r) {
        return n + r;
    }), N = F2(function(n, r) {
        return n + r;
    }), _ = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, s(u), r);
        }
        return r;
    }), E = F2(function(n, r) {
        return r.split(n);
    }), T = F2(function(n, r) {
        return r.join(n);
    }), C = F3(function(n, r, t) {
        return t.slice(n, r);
    }), L = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(s(e))) return !1;
        }
        return !0;
    }), O = F2(function(n, r) {
        return 0 === r.indexOf(n);
    });
    function S(n) {
        return {
            $: 2,
            b: n
        };
    }
    S(function(n) {
        return "number" != typeof n ? P("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? xr(n) : !isFinite(n) || n % 1 ? P("an INT", n) : xr(n);
    }), S(function(n) {
        return "boolean" == typeof n ? xr(n) : P("a BOOL", n);
    }), S(function(n) {
        return "number" == typeof n ? xr(n) : P("a FLOAT", n);
    }), S(function(n) {
        return xr(n);
    });
    var x = S(function(n) {
        return "string" == typeof n ? xr(n) : n instanceof String ? xr(n + "") : P("a STRING", n);
    }), I = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function q(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var F = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), H = F2(function(n, r) {
        return q(n, [
            r
        ]);
    }), Y = F3(function(n, r, t) {
        return q(n, [
            r,
            t
        ]);
    }), D = F2(function(n, r) {
        try {
            return U(n, JSON.parse(r));
        } catch (n) {
            return Cr(A2(Lr, "This is not valid JSON! " + n.message, r));
        }
    }), J = F2(function(n, r) {
        return U(n, r);
    });
    function U(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? xr(n.c) : P("null", r);
            case 3:
                return z(r) ? V(n.b, r, g) : P("a LIST", r);
            case 4:
                return z(r) ? V(n.b, r, B) : P("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return P("an OBJECT with a field named `" + t + "`", r);
                var e = U(n.b, r[t]);
                return At(e) ? e : Cr(A2(Or, t, e.a));
            case 7:
                var u = n.e;
                return z(r) ? r.length > u ? (e = U(n.b, r[u]), At(e) ? e : Cr(A2(Sr, u, e.a))) : P("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : P("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || z(r)) return P("an OBJECT", r);
                var a = l;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = U(n.b, r[i]), !At(e)) return Cr(A2(Or, i, e.a));
                    a = $(c(i, e.a), a);
                }
                return xr(Kr(a));
            case 9:
                for(var f = n.f, o = n.g, v = 0; o.length > v; v++){
                    if (e = U(o[v], r), !At(e)) return e;
                    f = f(e.a);
                }
                return xr(f);
            case 10:
                return e = U(n.b, r), At(e) ? U(n.h(e.a), r) : e;
            case 11:
                for(var s = l, b = n.g; b.b; b = b.b){
                    if (e = U(b.a, r), At(e)) return e;
                    s = $(e.a, s);
                }
                return Cr(Ir(Kr(s)));
            case 1:
                return Cr(A2(Lr, n.a, r));
            case 0:
                return xr(n.a);
        }
    }
    function V(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = U(n, r[a]);
            if (!At(i)) return Cr(A2(Sr, a, i.a));
            u[a] = i.a;
        }
        return xr(t(u));
    }
    function z(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function B(n) {
        return A2(Rt, n.length, function(r) {
            return n[r];
        });
    }
    function P(n, r) {
        return Cr(A2(Lr, "Expecting " + n, r));
    }
    function M(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return M(n.b, r.b);
            case 6:
                return n.d === r.d && M(n.b, r.b);
            case 7:
                return n.e === r.e && M(n.b, r.b);
            case 9:
                return n.f === r.f && Q(n.g, r.g);
            case 10:
                return n.h === r.h && M(n.b, r.b);
            case 11:
                return Q(n.g, r.g);
        }
    }
    function Q(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!M(n[e], r[e])) return !1;
        return !0;
    }
    var W = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function G(n) {
        return n;
    }
    function X(n) {
        return n;
    }
    var Z = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function K(n) {
        return {
            $: 0,
            a: n
        };
    }
    function nn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var rn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), tn = 0;
    function en(n) {
        var r = {
            $: 0,
            e: tn++,
            f: n,
            g: null,
            h: []
        };
        return vn(r), r;
    }
    function un(n) {
        return nn(function(r) {
            r(K(en(n)));
        });
    }
    function an(n, r) {
        n.h.push(r), vn(n);
    }
    var fn = F2(function(n, r) {
        return nn(function(t) {
            an(n, r), t(K(0));
        });
    }), on = !1, cn = [];
    function vn(n) {
        if (cn.push(n), !on) {
            for(on = !0; n = cn.shift();)sn(n);
            on = !1;
        }
    }
    function sn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, vn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var bn = {};
    function dn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function ln(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function f(n) {
            return A2(rn, f, {
                $: 5,
                b: function(r) {
                    var f = r.a;
                    return 0 === r.$ ? A3(u, t, f, n) : a && i ? A4(e, t, f.i, f.j, n) : A3(e, t, a ? f.i : f.j, n);
                }
            });
        }
        return t.h = en(A2(rn, f, n.b));
    }
    var $n = F2(function(n, r) {
        return nn(function(t) {
            n.g(r), t(K(0));
        });
    }), hn = F2(function(n, r) {
        return A2(fn, n.h, {
            $: 0,
            a: r
        });
    });
    function gn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function pn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var mn = [], wn = !1;
    function yn(n, r, t) {
        if (mn.push({
            p: n,
            q: r,
            r: t
        }), !wn) {
            wn = !0;
            for(var e; e = mn.shift();)Rn(e.p, e.q, e.r);
            wn = !1;
        }
    }
    function Rn(n, r, t) {
        var e = {};
        for(var u in An(!0, r, e, null), An(!1, t, e, null), n)an(n[u], {
            $: "fx",
            a: e[u] || {
                i: l,
                j: l
            }
        });
    }
    function An(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? bn[r].e : bn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = $(r, t.i) : t.j = $(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)An(n, i.a, t, e);
                return;
            case 3:
                return void An(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function jn(n) {
        bn[n] && u(3);
    }
    function kn(n, r) {
        return jn(n), bn[n] = {
            e: Nn,
            u: r,
            a: _n
        }, gn(n);
    }
    var Nn = F2(function(n, r) {
        return r;
    });
    function _n(n) {
        var r = [], t = bn[n].u, e = nn(function(n) {
            var r = setTimeout(function() {
                n(K(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return bn[n].b = e, bn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = X(t(u.a)), f = 0; a.length > f; f++)a[f](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    var En = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    var Tn = "undefined" != typeof document ? document : {};
    function Cn(n, r) {
        n.appendChild(r);
    }
    function Ln(n) {
        return {
            $: 0,
            a: n
        };
    }
    var On = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Dn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Dn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var Sn, xn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), In = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), qn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Fn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Hn = /^(on|formAction$)/i, Yn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Dn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Jn(i, u, a) : i[u] = a;
            } else "className" === u ? Jn(r, u, X(a)) : r[u] = X(a);
        }
        return r;
    }
    function Jn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Un(n, r) {
        var t = n.$;
        if (5 === t) return Un(n.k || (n.k = n.m()), r);
        if (0 === t) return Tn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Un(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Vn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Tn.createElementNS(n.f, n.c) : Tn.createElement(n.c);
        Vn(i, r, n.d);
        for(var f = n.e, o = 0; f.length > o; o++)Cn(i, Un(1 === t ? f[o] : f[o].b, r));
        return i;
    }
    function Vn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? zn(n, u) : "a0" === e ? Mn(n, r, u) : "a3" === e ? Bn(n, u) : "a4" === e ? Pn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function zn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Bn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Pn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Mn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Qn(r, a), n.addEventListener(u, i, Sn && {
                    passive: 2 > Et(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Sn = !0;
            }
        }));
    } catch (n) {}
    function Qn(n, r) {
        function t(r) {
            var e = t.q, u = U(e.a, r);
            if (At(u)) {
                for(var a, i = Et(e), f = u.a, o = i ? 3 > i ? f.a : f.s : f, c = 1 == i ? f.b : 3 == i && f.ad, v = (c && r.stopPropagation(), (2 == i ? f.b : 3 == i && f._) && r.preventDefault(), n); a = v.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var s = a.length; s--;)o = a[s](o);
                    v = v.p;
                }
                v(o, c);
            }
        }
        return t.q = r, t;
    }
    function Wn(n, r) {
        return n.$ == r.$ && M(n.a, r.a);
    }
    function Gn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Xn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Gn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, f = r.l, o = i.length, c = o === f.length; c && o--;)c = i[o] === f[o];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var v = [];
                    return Xn(n.k, r.k, v, 0), void (v.length > 0 && Gn(t, 1, e, v));
                case 4:
                    for(var s = n.j, b = r.j, d = !1, l = n.k; 4 === l.$;)d = !0, "object" != typeof s ? s = [
                        s,
                        l.j
                    ] : s.push(l.j), l = l.k;
                    for(var $ = r.k; 4 === $.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        $.j
                    ] : b.push($.j), $ = $.k;
                    return d && s.length !== b.length ? void Gn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(s, b) : s === b) || Gn(t, 2, e, b), void Xn(l, $, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Gn(t, 3, e, r.a));
                case 1:
                    return void Zn(n, r, t, e, nr);
                case 2:
                    return void Zn(n, r, t, e, rr);
                case 3:
                    if (n.h !== r.h) return void Gn(t, 0, e, r);
                    var h = Kn(n.d, r.d);
                    h && Gn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Gn(t, 5, e, g));
            }
        }
    }
    function Zn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Kn(n.d, r.d);
            a && Gn(t, 4, e, a), u(n, r, t, e);
        } else Gn(t, 0, e, r);
    }
    function Kn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Wn(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var f = Kn(n[u], r[u] || {}, u);
            f && ((e = e || {})[u] = f);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function nr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, f = a.length;
        i > f ? Gn(t, 6, e, {
            v: f,
            i: i - f
        }) : f > i && Gn(t, 7, e, {
            v: i,
            e: a
        });
        for(var o = f > i ? i : f, c = 0; o > c; c++){
            var v = u[c];
            Xn(v, a[c], t, ++e), e += v.b || 0;
        }
    }
    function rr(n, r, t, e) {
        for(var u = [], a = {}, i = [], f = n.e, o = r.e, c = f.length, v = o.length, s = 0, b = 0, d = e; c > s && v > b;){
            var l = (N = f[s]).a, $ = (_ = o[b]).a, h = N.b, g = _.b, p = void 0, m = void 0;
            if (l !== $) {
                var w = f[s + 1], y = o[b + 1];
                if (w) {
                    var R = w.a, A = w.b;
                    m = $ === R;
                }
                if (y) {
                    var j = y.a, k = y.b;
                    p = l === j;
                }
                if (p && m) Xn(h, k, u, ++d), er(a, u, l, g, b, i), d += h.b || 0, ur(a, u, l, A, ++d), d += A.b || 0, s += 2, b += 2;
                else if (p) d++, er(a, u, $, g, b, i), Xn(h, k, u, d), d += h.b || 0, s += 1, b += 2;
                else if (m) ur(a, u, l, h, ++d), d += h.b || 0, Xn(A, g, u, ++d), d += A.b || 0, s += 2, b += 1;
                else {
                    if (!w || R !== j) break;
                    ur(a, u, l, h, ++d), er(a, u, $, g, b, i), d += h.b || 0, Xn(A, k, u, ++d), d += A.b || 0, s += 2, b += 2;
                }
            } else Xn(h, g, u, ++d), d += h.b || 0, s++, b++;
        }
        for(; c > s;){
            var N;
            d++, ur(a, u, (N = f[s]).a, h = N.b, d), d += h.b || 0, s++;
        }
        for(; v > b;){
            var _, E = E || [];
            er(a, u, (_ = o[b]).a, _.b, void 0, E), b++;
        }
        (u.length > 0 || i.length > 0 || E) && Gn(t, 8, e, {
            w: u,
            x: i,
            y: E
        });
    }
    var tr = "_elmW6BL";
    function er(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var f = [];
            return Xn(i.z, e, f, i.r), i.r = u, void (i.s.s = {
                w: f,
                A: i
            });
        }
        er(n, r, t + tr, e, u, a);
    }
    function ur(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Xn(e, a.z, i, u), void Gn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            ur(n, r, t + tr, e, u);
        } else {
            var f = Gn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: f
            };
        }
    }
    function ar(n, r, t, e) {
        ir(n, r, t, 0, 0, r.b, e);
    }
    function ir(n, r, t, e, u, a, i) {
        for(var f = t[e], o = f.r; o === u;){
            var c = f.$;
            if (1 === c) ar(n, r.k, f.s, i);
            else if (8 === c) f.t = n, f.u = i, (v = f.s.w).length > 0 && ir(n, r, v, 0, u, a, i);
            else if (9 === c) {
                f.t = n, f.u = i;
                var v, s = f.s;
                s && (s.A.s = n, (v = s.w).length > 0 && ir(n, r, v, 0, u, a, i));
            } else f.t = n, f.u = i;
            if (!(f = t[++e]) || (o = f.r) > a) return e;
        }
        var b = r.$;
        if (4 === b) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return ir(n, d, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var l = r.e, $ = n.childNodes, h = 0; l.length > h; h++){
            u++;
            var g = 1 === b ? l[h] : l[h].b, p = u + (g.b || 0);
            if (!(u > o || o > p || (f = t[e = ir($[h], g, t, e, u, p, i)]) && (o = f.r) <= a)) return e;
            u = p;
        }
        return e;
    }
    function fr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = or(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function or(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Un(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Vn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return fr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, i = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Un(a[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var f = t.A;
                return void 0 !== f.r && n.parentNode.removeChild(n), f.s = fr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = Tn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                Cn(t, 2 === u.c ? u.s : Un(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = fr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], f = i.A, o = 2 === f.c ? f.s : Un(f.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && Cn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function cr(n) {
        if (3 === n.nodeType) return Ln(n.textContent);
        if (1 !== n.nodeType) return Ln("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = $(A2(Fn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = l, f = n.childNodes;
        for(e = f.length; e--;)i = $(cr(f[e]), i);
        return A3(On, a, r, i);
    }
    var vr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, i) {
            var f = A2(J, n, r ? r.flags : void 0);
            At(f) || u(2);
            var o = {}, c = t(f.a), v = c.a, s = i(d, v), b = function(n, r) {
                var t;
                for(var e in bn){
                    var u = bn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = ln(u, r);
                }
                return t;
            }(o, d);
            function d(n, r) {
                var t = A2(e, n, v);
                s(v = t.a, r), yn(o, t.b, a(v));
            }
            return yn(o, c.b, a(v)), b ? {
                ports: b
            } : {};
        }(r, e, n.bf, n.bw, n.bu, function(r, t) {
            var u = n.bx, a = e.node, i = cr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (sr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && sr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Xn(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (ar(n, r, t, e), fr(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), sr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var br = F3(function(n, r, t) {
        return nn(function(e) {
            function u(n) {
                e(r(t.S.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(be);
            }), a.addEventListener("timeout", function() {
                u($e);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? se : ce, function(n) {
                        return {
                            ag: n.responseURL,
                            aW: n.status,
                            bs: n.statusText,
                            V: dr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.S.b, a));
            }), pe(t.af) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || en(A2(me, n, c(t, le({
                        br: e.loaded,
                        aU: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || en(A2(me, n, c(t, de({
                        bn: e.loaded,
                        aU: e.lengthComputable ? Rr(e.total) : Ar
                    }))));
                });
            }(n, a, t.af.a);
            try {
                a.open(t.Y, t.ag, !0);
            } catch (n) {
                return u(ve(t.ag));
            }
            return function(n, r) {
                for(var t = r.V; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.ae.a || 0, n.responseType = r.S.d, n.withCredentials = r.a3;
            }(a, t), t.R.a && a.setRequestHeader("Content-Type", t.R.a), a.send(t.R.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function dr(n) {
        if (!n) return ge;
        for(var r = ge, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), f = u.substring(a + 2);
                r = A3(Se, i, function(n) {
                    return Rr(pe(n) ? f + ", " + n.a : f);
                }, r);
            }
        }
        return r;
    }
    var lr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), $r = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), hr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gr = F2(function(n, r) {
        return nn(function() {
            var t = setInterval(function() {
                en(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), pr = F2(function(n, r) {
        var t = "g";
        n.bi && (t += "m"), n.a5 && (t += "i");
        try {
            return Rr(RegExp(r, t));
        } catch (n) {
            return Ar;
        }
    }), mr = F2(function(n, r) {
        return null !== r.match(n);
    }), wr = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, f = 0; i && a > f;){
            var o = u.charCodeAt(r);
            i = n[f++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[f++] === u[r++] : 1));
        }
        return v(i ? r : -1, t, e);
    }), yr = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), Rr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ar = {
        $: 1
    }, jr = h, kr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(kr, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Nr = function(n) {
        return A3(kr, F3(function(n, r, t) {
            return A2(jr, c(n, r), t);
        }), l, n);
    }, _r = 1, Er = 2, Tr = 0, Cr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Or = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Sr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), xr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ir = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qr = L, Fr = W, Hr = function(n) {
        return n + "";
    }, Yr = F2(function(n, r) {
        return A2(T, n, p(r));
    }), Dr = F2(function(n, r) {
        return g(A2(E, n, r));
    }), Jr = function(n) {
        return A2(Yr, "\n    ", A2(Dr, "\n", n));
    }, Ur = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Vr = function(n) {
        return A3(Ur, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, zr = m, Br = F3(function(n, r, t) {
        for(;;){
            if (f(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(jr, r, t);
            n = e, r = u, t = a;
        }
    }), Pr = F2(function(n, r) {
        return A3(Br, n, r, l);
    }), Mr = F2(function(n, r) {
        return A3(zr, n, A2(Pr, 0, Vr(r) - 1), r);
    }), Qr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Wr = function(n) {
        var r = Qr(n);
        return r >= 97 && 122 >= r;
    }, Gr = function(n) {
        var r = Qr(n);
        return 90 >= r && r >= 65;
    }, Xr = function(n) {
        var r = Qr(n);
        return 57 >= r && r >= 48;
    }, Zr = function(n) {
        return Wr(n) || Gr(n) || Xr(n);
    }, Kr = function(n) {
        return A3(Ur, jr, l, n);
    }, nt = F2(function(n, r) {
        return "\n\n(" + Hr(n + 1) + ") " + Jr(rt(r));
    }), rt = function(n) {
        return A2(tt, n, l);
    }, tt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0), isNaN(r) ? Ar : Rr(55296 > r || r > 56319 ? c(n[0], n.slice(1)) : c(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var u, a = e.a, i = a.b;
                    return (Wr(u = a.a) || Gr(u)) && A2(qr, Zr, i);
                }();
                n = e, r = A2(jr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + Hr(n.a) + "]";
                n = e, r = A2(jr, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var f = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Yr, "", Kr(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Hr(Vr(i)) + " ways:";
                        return A2(Yr, "\n\n", A2(jr, f, A2(Mr, nt, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Yr, "", Kr(r)) : "!";
                }();
            default:
                var o = n.a, v = n.b;
                return (f = function() {
                    return r.b ? "Problem with the value at json" + A2(Yr, "", Kr(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Jr(A2(Fr, 4, v)) + "\n\n") + o;
        }
    }), et = 32, ut = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), at = [], it = y, ft = F2(function(n, r) {
        return j(r) / j(n);
    }), ot = it(A2(ft, 2, et)), ct = A4(ut, 0, ot, at, at), vt = t, st = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bt = F2(function(n, r) {
        return n(r);
    }), dt = R, lt = function(n) {
        return n.length;
    }, $t = F2(function(n, r) {
        return f(n, r) > 0 ? n : r;
    }), ht = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gt = e, pt = F2(function(n, r) {
        for(;;){
            var t = A2(gt, et, n), e = t.b, u = A2(jr, ht(t.a), r);
            if (!e.b) return Kr(u);
            n = e, r = u;
        }
    }), mt = F2(function(n, r) {
        for(;;){
            var t = it(r / et);
            if (1 === t) return A2(gt, et, n).a;
            n = A2(pt, n, l), r = t;
        }
    }), wt = F2(function(n, r) {
        if (r.e) {
            var t = r.e * et, e = dt(A2(ft, et, t - 1)), u = n ? Kr(r.h) : r.h, a = A2(mt, u, r.e);
            return A4(ut, lt(r.g) + t, A2($t, 5, e * ot), a, r.g);
        }
        return A4(ut, lt(r.g), ot, at, r.g);
    }), yt = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(wt, !1, {
                h: e,
                e: t / et | 0,
                g: u
            });
            var a = st(A3(vt, et, r, n));
            r -= et, e = A2(jr, a, e);
        }
    }), Rt = F2(function(n, r) {
        if (n > 0) {
            var t = n % et;
            return A5(yt, r, n - t - et, n, l, A3(vt, t, n - t, r));
        }
        return ct;
    }), At = function(n) {
        return !n.$;
    }, jt = F, kt = H, Nt = Y, _t = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Et = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Tt = function(n) {
        return n;
    }, Ct = function(n) {
        return n.length;
    }, Lt = C, Ot = F2(function(n, r) {
        return 1 > n ? r : A3(Lt, n, Ct(r), r);
    }), St = O, xt = K, It = xt(0), qt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, f = a.b;
                if (f.b) {
                    var o = f.a, c = f.b;
                    if (c.b) {
                        var v = c.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, c.a, t > 500 ? A3(Ur, n, r, Kr(v)) : A4(qt, n, r, t + 1, v)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Ft = F3(function(n, r, t) {
        return A4(qt, n, r, 0, t);
    }), Ht = F2(function(n, r) {
        return A3(Ft, F2(function(r, t) {
            return A2(jr, n(r), t);
        }), l, r);
    }), Yt = rn, Dt = F2(function(n, r) {
        return A2(Yt, function(r) {
            return xt(n(r));
        }, r);
    }), Jt = F3(function(n, r, t) {
        return A2(Yt, function(r) {
            return A2(Yt, function(t) {
                return xt(A2(n, r, t));
            }, t);
        }, r);
    }), Ut = function(n) {
        return A3(Ft, Jt(jr), xt(l), n);
    }, Vt = $n, zt = F2(function(n, r) {
        var t = r;
        return un(A2(Yt, Vt(n), t));
    });
    bn.Task = dn(It, F3(function(n, r) {
        return A2(Dt, function() {
            return 0;
        }, Ut(A2(Ht, zt(n), r)));
    }), F3(function() {
        return xt(0);
    }), F2(function(n, r) {
        return A2(Dt, n, r);
    }));
    var Bt = gn("Task"), Pt = F2(function(n, r) {
        return Bt(A2(Dt, n, r));
    }), Mt = vr, Qt = I, Wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gt = {
        $: 0
    }, Xt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zt = pn, Kt = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ne = function(n) {
        return {
            $: 5,
            a: n
        };
    }, re = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), te = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ee = {
        $: 3
    }, ue = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ae = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ie = {
        $: 4
    }, fe = F3(function(n, r, t) {
        return r(n(t));
    }), oe = D, ce = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ve = function(n) {
        return {
            $: 0,
            a: n
        };
    }, se = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), be = {
        $: 2
    }, de = function(n) {
        return {
            $: 1,
            a: n
        };
    }, le = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $e = {
        $: 1
    }, he = {
        $: -2
    }, ge = he, pe = function(n) {
        return !n.$;
    }, me = hn, we = o, ye = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ar;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(we, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Rr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Re = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Ae = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Re, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Re, 0, e.b, e.c, A5(Re, 1, a.b, a.c, a.d, a.e), A5(Re, 1, r, t, i, u));
        }
        var i, f = u.b, o = u.c, c = u.d, v = u.e;
        return -1 !== e.$ || e.a ? A5(Re, n, f, o, A5(Re, 0, r, t, e, c), v) : A5(Re, 0, r, t, A5(Re, 1, e.b, e.c, e.d, i = e.e), A5(Re, 1, f, o, c, v));
    }), je = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Re, 0, n, r, he, he);
        var e = t.a, u = t.b, a = t.c, i = t.d, f = t.e;
        switch(A2(we, n, u)){
            case 0:
                return A5(Ae, e, u, a, A3(je, n, r, i), f);
            case 1:
                return A5(Re, e, u, r, i, f);
            default:
                return A5(Ae, e, u, a, i, A3(je, n, r, f));
        }
    }), ke = F3(function(n, r, t) {
        var e = A3(je, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Re, 1, e.b, e.c, e.d, e.e);
    }), Ne = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, f = t.c, e = t.d, v = t.e, A5(Re, 1, n.b, n.c, A5(Re, 0, r.b, r.c, r.d, r.e), A5(Re, 0, i, f, e, v));
            }
            var e, u = n.d, a = n.e, i = a.b, f = a.c, o = (e = a.d).d, c = e.e, v = a.e;
            return A5(Re, 0, e.b, e.c, A5(Re, 1, n.b, n.c, A5(Re, 0, u.b, u.c, u.d, u.e), o), A5(Re, 1, i, f, c, v));
        }
        return n;
    }, _e = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, v = t.c, s = t.d, b = t.e, A5(Re, 1, e = n.b, u = n.c, A5(Re, 0, r.b, r.c, r.d, f = r.e), A5(Re, 0, c, v, s, b));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, f = a.e, o = n.e, c = o.b, v = o.c, s = o.d, b = o.e;
            return A5(Re, 0, a.b, a.c, A5(Re, 1, i.b, i.c, i.d, i.e), A5(Re, 1, e, u, f, A5(Re, 0, c, v, s, b)));
        }
        return n;
    }, Ee = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return _e(r);
                        break n;
                    }
                    return _e(r);
                }
                break n;
            }
            return r;
        }
        return A5(Re, t, a.b, a.c, a.d, A5(Re, 0, e, u, a.e, i));
    }), Te = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var f = Ne(n);
                    if (-1 === f.$) {
                        var o = f.e;
                        return A5(Ae, f.a, f.b, f.c, Te(f.d), o);
                    }
                    return he;
                }
                return A5(Re, r, t, e, Te(u), i);
            }
            return A5(Re, r, t, e, Te(u), i);
        }
        return he;
    }, Ce = F2(function(n, r) {
        if (-2 === r.$) return he;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > f(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var c = Ne(r);
                    if (-1 === c.$) {
                        var v = c.e;
                        return A5(Ae, c.a, c.b, c.c, A2(Ce, n, c.d), v);
                    }
                    return he;
                }
                return A5(Re, t, e, u, A2(Ce, n, a), i);
            }
            return A5(Re, t, e, u, A2(Ce, n, a), i);
        }
        return A2(Le, n, A7(Ee, n, r, t, e, u, a, i));
    }), Le = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, i = r.d, f = r.e;
            if (a(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(f);
                return -1 === o.$ ? A5(Ae, t, o.b, o.c, i, Te(f)) : he;
            }
            return A5(Ae, t, e, u, i, A2(Ce, n, f));
        }
        return he;
    }), Oe = F2(function(n, r) {
        var t = A2(Ce, n, r);
        return -1 !== t.$ || t.a ? t : A5(Re, 1, t.b, t.c, t.d, t.e);
    }), Se = F3(function(n, r, t) {
        var e = r(A2(ye, n, t));
        return e.$ ? A2(Oe, n, t) : A3(ke, n, e.a, t);
    }), xe = F2(function(n, r) {
        return A3(lr, "", Tt, A2(fe, r, n));
    }), Ie = F2(function(n, r) {
        var t = function(n) {
            switch(n.$){
                case 4:
                    var t = A2(oe, r, n.b);
                    return t.$ ? Cr({
                        $: 2,
                        a: rt(t.a)
                    }) : xr(t.a);
                case 3:
                    var e = n.a.aW;
                    return Cr(A2(500 > e ? re : ue, e, n.b));
                case 0:
                    return Cr(ne(n.a));
                case 1:
                    return Cr(ie);
                default:
                    return Cr(ee);
            }
        };
        return A2(xe, A2(fe, function(n) {
            return n.$ ? te(n.a) : ae(n.a);
        }, n), t);
    }), qe = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fe = F2(function(n, r) {
        return {
            aN: n,
            aX: r
        };
    }), He = xt(A2(Fe, ge, l)), Ye = function(n) {
        return nn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(K(0));
        });
    }, De = un, Je = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Yt, function(r) {
                        var e = a.af;
                        return A3(Je, n, u, 1 === e.$ ? t : A3(ke, e.a, r, t));
                    }, De(A3(br, n, Vt(n), a)));
                }
                var i = e.a, f = A2(ye, i, t);
                if (1 === f.$) {
                    r = u;
                    continue n;
                }
                return A2(Yt, function() {
                    return A3(Je, n, u, A2(Oe, i, t));
                }, Ye(f.a));
            }
            return xt(t);
        }
    }), Ue = F4(function(n, r, t, e) {
        return A2(Yt, function(n) {
            return xt(A2(Fe, n, t));
        }, A3(Je, n, r, e.aN));
    }), Ve = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(jr, e.a, t);
    }), ze = F2(function(n, r) {
        return A3(Ft, Ve(n), l, r);
    }), Be = F4(function(n, r, t, e) {
        var u = e.b;
        return a(r, e.a) ? Rr(A2(Vt, n, u(t))) : Ar;
    }), Pe = F3(function(n, r, t) {
        return A2(Yt, function() {
            return xt(t);
        }, Ut(A2(ze, A3(Be, n, r.a, r.b), t.aX)));
    }), Me = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return qe({
                a3: t.a3,
                R: t.R,
                S: A2($r, n, t.S),
                V: t.V,
                Y: t.Y,
                ae: t.ae,
                af: t.af,
                ag: t.ag
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), Qe = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    bn.Http = dn(He, Ue, Pe, Me, F2(function(n, r) {
        return A2(Qe, r.a, A2(fe, r.b, n));
    }));
    var We, Ge = gn("Http"), Xe = (gn("Http"), function(n) {
        return Ge(qe({
            a3: !0,
            R: n.R,
            S: n.S,
            V: n.V,
            Y: n.Y,
            ae: n.ae,
            af: n.af,
            ag: n.ag
        }));
    }), Ze = hr, Ke = F2(function(n, r) {
        return {
            aB: n,
            bq: r
        };
    }), nu = F2(function(n, r) {
        return A3(Ft, Qt, r, n);
    }), ru = x, tu = A3(Nt, Ke, A2(nu, g([
        "email"
    ]), ru), A2(nu, g([
        "roles"
    ]), {
        $: 3,
        b: ru
    })), eu = function(n) {
        return Xe({
            R: A2(Ze, "application/json", ""),
            S: A2(Ie, Kt, tu),
            V: l,
            Y: "get",
            ae: Ar,
            af: Ar,
            ag: n.u + "/user/info"
        });
    }, uu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), au = uu, iu = nn(function(n) {
        n(K(A2(au, -(new Date).getTimezoneOffset(), l)));
    }), fu = F2(function(n, r) {
        return r.$ ? Cr(r.a) : n(r.a);
    }), ou = F2(function(n, r) {
        return r.$ ? Cr(r.a) : xr(n(r.a));
    }), cu = function(n) {
        return n.toLowerCase();
    }, vu = function(n) {
        return "qr_" + cu(A2(Ot, 3, n));
    }, su = {
        $: 3
    }, bu = function(n) {
        return A2(St, "qr_", n) ? xr(n) : Cr(su);
    }, du = {
        $: 4
    }, lu = {
        $: 6
    }, $u = {
        $: 5
    }, hu = mr, gu = pr, pu = function(n) {
        return A2(gu, {
            a5: !1,
            bi: !1
        }, n);
    }, mu = pu("^[0-9a-f-]+$"), wu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), yu = F2(function(n, r) {
        return A2(wu, function(r) {
            return a(r, n);
        }, r);
    }), Ru = pu("^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"), Au = function(n) {
        var r = cu(A2(Ot, 3, n));
        return !Ru.$ && A2(hu, Ru.a, r) ? xr(n) : function(n) {
            return mu.$ || !A2(hu, mu.a, n) ? Cr(du) : "4" !== A3(Lt, 14, 15, n) || A2(yu, A3(Lt, 19, 20, n), g([
                "8",
                "9",
                "a",
                "b"
            ])) ? Cr($u) : Cr(lu);
        }(r);
    }, ju = function(n) {
        var r;
        return r = A2(ou, vu, A2(fu, Au, A2(fu, bu, function(n) {
            return 39 === Ct(n) ? xr(n) : Cr({
                $: 2,
                a: Ct(n)
            });
        }(n)))), r.$ ? {
            $: 1,
            a: r.a
        } : {
            $: 0,
            a: r.a
        };
    }, ku = F2(function(n, r) {
        return r.$ ? Ar : Rr(n(r.a));
    }), Nu = Tt, _u = (We = Nu, nn(function(n) {
        n(K(We(Date.now())));
    })), Eu = A2(uu, 0, l), Tu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Cu = pn, Lu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ou = F2(function(n, r) {
        return {
            aJ: r,
            aY: n
        };
    }), Su = xt(A2(Ou, ge, ge)), xu = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(ye, t, r);
        return A3(ke, t, 1 === u.$ ? g([
            e
        ]) : A2(jr, e, u.a), r);
    }), Iu = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(Iu, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), qu = F6(function(n, r, t, e, u, a) {
        var i = A3(Iu, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var v = i.a, s = v.a, b = v.b, d = i.b;
                    if (0 > f(s, e)) {
                        a = c(d, A3(n, s, b, o));
                        continue n;
                    }
                    return f(s, e) > 0 ? c(i, A3(t, e, u, o)) : c(d, A4(r, s, b, u, o));
                }
                return c(i, A3(t, e, u, o));
            }
        }), c(Nr(e), a), u), o = i.a, v = i.b;
        return A3(Ur, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), v, o);
    }), Fu = gr, Hu = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = De(A2(Fu, e, A2(me, n, e)));
            return A2(Yt, function(r) {
                return A3(Hu, n, u, A3(ke, e, r, t));
            }, a);
        }
        return xt(t);
    }), Yu = F3(function(n, r, t) {
        var e = t.aJ, u = F3(function(n, r, t) {
            var e = t.c;
            return v(t.a, t.b, A2(Yt, function() {
                return e;
            }, Ye(r)));
        }), a = A3(Ur, xu, ge, r), i = A6(qu, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return v(A2(jr, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return v(e.a, A3(ke, n, t, e.b), u);
        }), u, a, e, v(l, ge, xt(0))), f = i.a, o = i.b;
        return A2(Yt, function(n) {
            return xt(A2(Ou, a, n));
        }, A2(Yt, function() {
            return A3(Hu, n, f, o);
        }, i.c));
    }), Du = F3(function(n, r, t) {
        var e = A2(ye, r, t.aY);
        if (1 === e.$) return xt(t);
        var u = e.a;
        return A2(Yt, function() {
            return xt(t);
        }, A2(Yt, function(r) {
            return Ut(A2(Ht, function(t) {
                return A2(Vt, n, t(r));
            }, u));
        }, _u));
    }), Ju = F3(function(n, r, t) {
        return n(r(t));
    });
    bn.Time = dn(Su, Yu, Du, 0, F2(function(n, r) {
        return A2(Lu, r.a, A2(Ju, n, r.b));
    }));
    var Uu, Vu, zu, Bu, Pu, Mu, Qu = gn("Time"), Wu = F2(function(n, r) {
        return Qu(A2(Lu, n, r));
    }), Gu = (Vu = ru, jn(Uu = "receiveCurrentUrl"), bn[Uu] = {
        f: En,
        u: Vu,
        a: function(n, r) {
            var t = l, e = bn[n].u, a = K(null);
            return bn[n].b = a, bn[n].c = F3(function(n, r) {
                return t = r, a;
            }), {
                send: function(n) {
                    var a = A2(J, e, n);
                    At(a) || u(4);
                    for(var i = a.a, f = t; f.b; f = f.b)r(f.a(i));
                }
            };
        }
    }, gn(Uu)), Xu = {
        $: 1
    }, Zu = kn("getCurrentUrl", function() {
        return null;
    }), Ku = function(n) {
        return {
            $: 5,
            a: n
        };
    }, na = F2(function(n, r) {
        return {
            T: r,
            aD: n
        };
    }), ra = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ta = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ea = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(ra, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var f = i.a;
                return A2(ra, u || f, i.b);
            }
            return f = i.a, A3(ta, u || f, i.b, i.c);
        };
    }), ua = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), aa = F4(function(n, r, t, e) {
        return {
            am: r,
            a7: e,
            aH: t,
            aR: n
        };
    }), ia = {
        $: 0
    }, fa = F2(function(n, r) {
        return A2(ua, ia, A4(aa, n.aR, n.am, r, n.c));
    }), oa = (zu = {
        $: 10
    }, function(n) {
        return a(Ct(n.a), n.b) ? A3(ta, !1, 0, n) : A2(ra, !1, A2(fa, n, zu));
    }), ca = yr, va = F5(function(n, r, t, e, u) {
        for(;;){
            var i = A3(ca, n, r, u.a);
            if (a(i, -1)) return A3(ta, 0 > f(u.b, r), 0, {
                am: e,
                c: u.c,
                d: u.d,
                b: r,
                aR: t,
                a: u.a
            });
            a(i, -2) ? (r += 1, t += 1, e = 1) : (r = i, e += 1);
        }
    }), sa = F2(function(n) {
        return n;
    }), ba = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(ra, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(ta, e.a, A2(n, A3(Lt, r.b, a.b, r.a), u), a);
        };
    }), da = function(n) {
        return A2(ba, sa, n);
    }, la = function(n) {
        return function(n) {
            return function(r) {
                return A2(ra, !1, A2(fa, r, n));
            };
        }({
            $: 12,
            a: n
        });
    }, $a = A, ha = function(n) {
        return function(r) {
            return A3(ta, !1, n, r);
        };
    }, ga = A2(ea, function(n) {
        if (Ct(n) > 9) return la("Expected at most 9 digits, but got " + Hr(Ct(n)));
        var r = function(n) {
            if (0 === n.length || /[\sxbo]/.test(n)) return Ar;
            var r = +n;
            return r == r ? Rr(r) : Ar;
        }("0." + n);
        return r.$ ? la('Invalid float: "' + n + '"') : ha($a(1e3 * r.a));
    }, da((Mu = Xr, function(n) {
        return A5(va, Mu, n.b, n.aR, n.am, n);
    }))), pa = F6(function(n, r, t, e, u, a) {
        return Nu(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), ma = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(ra, t.a, t.b);
            var a = t.a, i = t.b, f = u(t.c);
            if (1 === f.$) {
                var o = f.a;
                return A2(ra, a || o, f.b);
            }
            o = f.a;
            var c = f.c;
            return A3(ta, a || o, A2(n, i, f.b), c);
        };
    }), wa = F2(function(n, r) {
        return A3(ma, sa, n, r);
    }), ya = F2(function(n, r) {
        return A3(ma, bt, n, r);
    }), Ra = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Aa = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(Ra, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(ra, !1, r);
        }
    }), ja = function(n) {
        return function(r) {
            return A3(Aa, r, ia, n);
        };
    }, ka = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Na = N, _a = {
        $: 11
    }, Ea = F2(function(n, r) {
        return function(t) {
            var e = A3(ca, n, t.b, t.a);
            return a(e, -1) ? A2(ra, !1, A2(fa, t, r)) : a(e, -2) ? A3(ta, !0, 0, {
                am: 1,
                c: t.c,
                d: t.d,
                b: t.b + 1,
                aR: t.aR + 1,
                a: t.a
            }) : A3(ta, !0, 0, {
                am: t.am + 1,
                c: t.c,
                d: t.d,
                b: e,
                aR: t.aR,
                a: t.a
            });
        };
    }), Ta = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(ra, n || a, u.b);
            var a = u.a, i = u.b, f = u.c;
            if (i.$) return A3(ta, n || a, i.a, f);
            n = n || a, r = i.a, e = f;
        }
    }), Ca = F2(function(n, r) {
        return function(t) {
            return A4(Ta, !1, n, r, t);
        };
    }), La = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(ra, e.a, e.b);
            var u = e.c;
            return A3(ta, e.a, n(e.b), u);
        };
    }), Oa = function(n) {
        return n.$ ? {
            $: 1,
            a: n.a
        } : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, Sa = F2(function(n, r) {
        return A2(Ca, n, function(n) {
            return A2(La, Oa, r(n));
        });
    }), xa = function(n) {
        return A2(Sa, "", function(r) {
            if (a(Ct(r), n)) {
                var t = function(n) {
                    for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
                        var a = n.charCodeAt(u);
                        if (48 > a || a > 57) return Ar;
                        r = 10 * r + a - 48;
                    }
                    return u == e ? Ar : Rr(45 == t ? -r : r);
                }(r);
                return t.$ ? la('Invalid integer: "' + r + '"') : A2(La, ka, ha(t.a));
            }
            return A2(La, function(n) {
                return {
                    $: 0,
                    a: A2(Na, r, n)
                };
            }, da(A2(Ea, Xr, _a)));
        });
    }, Ia = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qa = wr, Fa = function(n) {
        return function(n) {
            var r = n.a, t = n.b, e = !("" === r);
            return function(n) {
                var u = A5(qa, r, n.b, n.aR, n.am, n.a), i = u.a, f = u.b, o = u.c;
                return a(i, -1) ? A2(ra, !1, A2(fa, n, t)) : A3(ta, e, 0, {
                    am: o,
                    c: n.c,
                    d: n.d,
                    b: i,
                    aR: f,
                    a: n.a
                });
            };
        }(A2(Ia, n, {
            $: 8,
            a: n
        }));
    }, Ha = function(n) {
        return la("Invalid day: " + Hr(n));
    }, Ya = w, Da = function(n) {
        return !(A2(Ya, 4, n) || !A2(Ya, 100, n) && A2(Ya, 400, n));
    }, Ja = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Ua = A2(ea, function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return Ha(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !Da(r) ? e - 1 : e) + (Ja(r) - Ja(1970)));
            return ha(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? Ha(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Da(r) ? Ha(e) : u(26784e5);
            case 3:
                return e > 31 ? Ha(e) : u(50976e5);
            case 4:
                return e > 30 ? Ha(e) : u(7776e6);
            case 5:
                return e > 31 ? Ha(e) : u(10368e6);
            case 6:
                return e > 30 ? Ha(e) : u(130464e5);
            case 7:
                return e > 31 ? Ha(e) : u(156384e5);
            case 8:
                return e > 31 ? Ha(e) : u(183168e5);
            case 9:
                return e > 30 ? Ha(e) : u(209952e5);
            case 10:
                return e > 31 ? Ha(e) : u(235872e5);
            case 11:
                return e > 30 ? Ha(e) : u(262656e5);
            case 12:
                return e > 31 ? Ha(e) : u(288576e5);
            default:
                return la('Invalid month: "' + Hr(t) + '"');
        }
    }, A2(ya, A2(ya, A2(ya, ha(F3(function(n, r, t) {
        return v(n, r, t);
    })), xa(4)), ja(g([
        A2(ya, A2(wa, ha(Tt), Fa("-")), xa(2)),
        xa(2)
    ]))), ja(g([
        A2(ya, A2(wa, ha(Tt), Fa("-")), xa(2)),
        xa(2)
    ])))), Va = (Bu = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(ya, ha(Tt), ja(g([
        A2(La, function() {
            return 0;
        }, Fa("Z")),
        A2(ya, A2(ya, A2(ya, ha(Bu), ja(g([
            A2(La, function() {
                return 1;
            }, Fa("+")),
            A2(La, function() {
                return -1;
            }, Fa("-"))
        ]))), xa(2)), ja(g([
            A2(ya, A2(wa, ha(Tt), Fa(":")), xa(2)),
            xa(2),
            ha(0)
        ]))),
        A2(wa, ha(0), oa)
    ])))), za = A2(ea, function(n) {
        return ja(g([
            A2(ya, A2(ya, A2(ya, A2(ya, A2(ya, A2(wa, ha(pa(n)), Fa("T")), xa(2)), ja(g([
                A2(ya, A2(wa, ha(Tt), Fa(":")), xa(2)),
                xa(2)
            ]))), ja(g([
                A2(ya, A2(wa, ha(Tt), Fa(":")), xa(2)),
                xa(2),
                ha(0)
            ]))), ja(g([
                A2(ya, A2(wa, ha(Tt), Fa(".")), ga),
                ha(0)
            ]))), A2(wa, Va, oa)),
            A2(wa, ha(A6(pa, n, 0, 0, 0, 0, 0)), oa)
        ]));
    }, Ua), Ba = F3(function(n, r, t) {
        return {
            am: r,
            aH: t,
            aR: n
        };
    }), Pa = function(n) {
        return A3(Ba, n.aR, n.am, n.aH);
    }, Ma = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(jr, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Ma, e, r);
                continue n;
        }
    }), Qa = F2(function(n, r) {
        var t = n({
            am: 1,
            c: l,
            d: 1,
            b: 0,
            aR: 1,
            a: r
        });
        return t.$ ? Cr(A2(Ma, t.b, l)) : xr(t.b);
    }), Wa = F2(function(n, r) {
        var t = A2(Qa, n, r);
        return t.$ ? Cr(A2(Ht, Pa, t.a)) : xr(t.a);
    }), Ga = A2(jt, function(n) {
        var r = function(n) {
            return A2(Wa, za, n);
        }(n);
        return r.$ ? {
            $: 1,
            a: "Invalid ISO 8601 timestamp: " + n
        } : _t(r.a);
    }, ru), Xa = A3(Nt, na, A2(nu, g([
        "otp"
    ]), ru), A2(nu, g([
        "expires_at"
    ]), Ga)), Za = G, Ka = F3(function(n, r, t) {
        var e, u = (e = g([
            c("email", Za(r)),
            c("qr_session_id", Za(t))
        ]), A2(hr, "application/json", A2(Fr, 0, A3(Ur, F2(function(n, r) {
            return A3(Z, n.a, n.b, r);
        }), {}, e))));
        return Xe({
            R: u,
            S: A2(Ie, Ku, Xa),
            V: l,
            Y: "post",
            ae: Ar,
            af: Ar,
            ag: n.u + "/getotp"
        });
    }), ni = F2(function(n, r) {
        return r.$ ? Ar : n(r.a);
    }), ri = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ti = Zt(l), ei = kn("redirectToLogin", Za), ui = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(b(r, {
                    F: n.a
                }), ti);
            case 1:
                return c(b(r, {
                    ai: n.a
                }), ti);
            case 2:
                return c(r, ti);
            case 3:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = b(r, {
                        Q: t
                    }), a = A2(ni, function(n) {
                        return n.O ? Rr(n) : Ar;
                    }, r.P);
                    if (a.$) return c(u, ti);
                    var i = a.a;
                    return c(b(u, {
                        I: Xu
                    }), A3(Ka, r.N, e.aB, i.W));
                }
                return c(r, Zu(0));
            case 4:
                var f = encodeURIComponent(n.a);
                return c(r, ei("https://login.genomicscore.be?uri=" + f));
            case 5:
                return c(b(r, {
                    I: n.a
                }), ti);
            case 6:
                return c(b(r, {
                    H: Xu
                }), (v = r.N, Xe({
                    R: A2(Ze, "application/json", ""),
                    S: (s = ri, d = function(n) {
                        switch(n.$){
                            case 4:
                                return xr(0);
                            case 3:
                                var r = n.a.aW;
                                return Cr(A2(500 > r ? re : ue, r, n.b));
                            case 0:
                                return Cr(ne(n.a));
                            case 1:
                                return Cr(ie);
                            default:
                                return Cr(ee);
                        }
                    }, A2(xe, A2(fe, function(n) {
                        return n.$ ? te(n.a) : ae(n.a);
                    }, s), d)),
                    V: l,
                    Y: "post",
                    ae: Ar,
                    af: Ar,
                    ag: v.u + "/logout"
                })));
            default:
                var o = n.a;
                switch(o.$){
                    case 3:
                        return c(r, Zu(0));
                    case 2:
                        return c(b(r, {
                            H: o
                        }), ti);
                    default:
                        return c(r, ti);
                }
        }
        var v, s, d;
    }), ai = {
        $: 6
    }, ii = F2(function(n, r) {
        return A2(qn, n, Za(r));
    }), fi = ii("className"), oi = k, ci = F3(function(n, r, t) {
        return n > 0 ? A3(ci, n >> 1, d(r, r), 1 & n ? d(t, r) : t) : t;
    }), vi = F2(function(n, r) {
        return A3(ci, n, r, "");
    }), si = F3(function(n, r, t) {
        return d(A2(vi, n - Ct(t), function(n) {
            return A2(oi, n, "");
        }(r)), t);
    }), bi = F2(function(n, r) {
        var t = n - r, e = A2(Ya, 60, t / 1e3 | 0);
        return Hr(t / 6e4 | 0) + ":" + A3(si, 2, "0", Hr(e));
    }), di = On("div"), li = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), $i = function(n) {
        return !n.b;
    }, hi = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(jr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), gi = F2(function(n, r) {
        return Kr(A3(hi, n, r, l));
    }), pi = F3(function(n, r, t) {
        if (r > 0) {
            var e = c(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return g([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return g([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var f = e.b, o = f.b, v = o.b, s = v.b, b = s.b;
                                return A2(jr, f.a, A2(jr, o.a, A2(jr, v.a, A2(jr, s.a, n > 1e3 ? A2(gi, r - 4, b) : A3(pi, n + 1, r - 4, b)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return g([
                e.b.a
            ]);
        }
        return l;
    }), mi = F2(function(n, r) {
        return A3(pi, 0, n, r);
    }), wi = F3(function(n, r, t) {
        return n > 0 && r > 0 ? A2(F2(function(t, e) {
            for(;;){
                if ($i(t)) return Kr(e);
                var u = A2(mi, n, t);
                if (!a(n, Vr(u))) return Kr(e);
                t = A2(li, r, t), e = A2(jr, u, e);
            }
        }), t, l) : l;
    }), yi = F2(function(n, r) {
        return A3(wi, n, n, r);
    }), Ri = On("h3"), Ai = On("input"), ji = In, ki = Ln, Ni = A2(di, g([
        A2(F2(function(n, r) {
            return A2(Fn, function(n) {
                return Hn.test(n) ? "data-" + n : n;
            }(n), function(n) {
                return Yn.test(n) ? "" : n;
            }(r));
        }), "aria-busy", "true"),
        A2(ji, "margin", "2rem")
    ]), g([
        ki("Loading...")
    ])), _i = xn, Ei = F2(function(n, r) {
        return A2(_i, n, {
            $: 0,
            a: r
        });
    }), Ti = On("p"), Ci = G, Li = F2(function(n, r) {
        return A2(qn, n, Ci(r));
    })("readOnly"), Oi = On("small"), Si = _, xi = ii("type"), Ii = ii("value"), qi = function(n) {
        switch(n.$){
            case 0:
                var r = n.b;
                return "Client error (" + Hr(n.a) + "): " + r;
            case 1:
                return r = n.b, "Server error (" + Hr(n.a) + "): " + r + " If this persists, please contact us through the helpdesk (https://help.genomicscore.be/helpdesk)";
            case 2:
                return "Decode error: " + n.a;
            case 3:
                return "Network error - please check your connection";
            case 4:
                return "Request timed out";
            default:
                return "Invalid URL: " + n.a;
        }
    }, Fi = function(n) {
        return A2(di, g([
            A2(ji, "margin", "2rem")
        ]), g([
            ki(qi(n))
        ]));
    };
    Pu = {
        Main: {
            init: Mt({
                bf: function(n) {
                    var r = A2(ku, function(n) {
                        var r;
                        return {
                            W: n,
                            O: (r = n, !ju(r).$)
                        };
                    }, n.aa), t = {
                        E: n.E,
                        u: n.u
                    };
                    return c({
                        N: t,
                        F: Nu(0),
                        H: Gt,
                        I: Gt,
                        P: r,
                        Q: Gt,
                        ai: Eu
                    }, Zt(g([
                        A2(Pt, Wt, iu),
                        A2(Pt, Xt, _u),
                        eu(t)
                    ])));
                },
                bu: function() {
                    return Cu(g([
                        A2(Wu, 1e3, Xt),
                        Gu(Tu)
                    ]));
                },
                bw: ui,
                bx: function(n) {
                    var r, t, e = F2(function(n, r) {
                        return A2(Yr, " ", A2(Ht, function(n) {
                            return p(n).join("");
                        }, A2(yi, n, A3(Si, jr, l, r))));
                    }), u = A2(di, l, g([
                        function() {
                            var r = n.I;
                            switch(r.$){
                                case 1:
                                    return Ni;
                                case 0:
                                    return ki("");
                                case 2:
                                    return Fi(r.a);
                                default:
                                    var t = r.a, u = f(n.F, t.T) > -1;
                                    return A2(di, l, g(u ? [
                                        A2(Ti, l, g([
                                            ki("Expired. Scan a new QR code!")
                                        ]))
                                    ] : [
                                        A2(Ai, g([
                                            A2(ji, "font-size", "32px"),
                                            A2(ji, "font-weight", "bold"),
                                            A2(ji, "font-family", "ui-monospace"),
                                            A2(ji, "text-align", "center"),
                                            Ii(A2(e, 3, t.aD)),
                                            Li(!0)
                                        ]), l),
                                        A2(Oi, l, g([
                                            ki("Expires in: " + A2(bi, t.T, n.F))
                                        ]))
                                    ]));
                            }
                        }()
                    ])), a = n.Q;
                    switch(a.$){
                        case 0:
                            return ki("");
                        case 1:
                            return Ni;
                        case 2:
                            return Fi(a.a);
                        default:
                            return A2(di, l, g([
                                A2(Ri, l, g([
                                    ki("GC Authenticator")
                                ])),
                                (t = n.P, t.$ ? A2(Ti, l, g([
                                    ki("Error: no QR code provided!")
                                ])) : t.a.O ? u : A2(Ti, l, g([
                                    ki("Error: QR code is invalid!")
                                ]))),
                                A2(Ai, g([
                                    xi("button"),
                                    fi("secondary"),
                                    (r = ai, A2(Ei, "click", _t(r))),
                                    Ii("Logout")
                                ]), l),
                                function() {
                                    var r = n.H;
                                    switch(r.$){
                                        case 1:
                                            return Ni;
                                        case 2:
                                            return Fi(r.a);
                                        default:
                                            return ki("");
                                    }
                                }()
                            ]));
                    }
                }
            })(A2(jt, function(n) {
                var r;
                return A2(jt, function(r) {
                    return A2(jt, function(t) {
                        return _t({
                            E: t,
                            aa: r,
                            u: n
                        });
                    }, A2(Qt, "backendUrl", ru));
                }, A2(Qt, "qrSessionId", {
                    $: 11,
                    g: g([
                        (r = Ar, {
                            $: 5,
                            c: r
                        }),
                        A2(kt, Rr, ru)
                    ])
                }));
            }, A2(Qt, "serviceUrl", ru)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Pu) : n.Elm = Pu;
}($a0b4f895e1596b3b$exports);


function $35da740d59af89ba$var$getQRHash() {
    const match = window.location.pathname.match(/^\/qr\/([^\/]+)$/);
    return match ? match[1] : null;
}
const $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("elm-app"),
    flags: {
        backendUrl: (0, $bebe1cbb5a309c8c$export$44487a86467333c3)()["backend-url"],
        serviceUrl: (0, $bebe1cbb5a309c8c$export$44487a86467333c3)()["services-url"],
        qrSessionId: $35da740d59af89ba$var$getQRHash()
    }
});
// Set up ports
document.onSignIn = function(googleUser) {
    var profile = googleUser.getBasicProfile();
    var token = googleUser.getAuthResponse().id_token;
    $35da740d59af89ba$var$app.ports.toElm.send(token);
};
// Handle redirect to login
$35da740d59af89ba$var$app.ports.redirectToLogin.subscribe(function(loginUrl) {
    window.location.href = loginUrl;
});
// Handle getting current URL
$35da740d59af89ba$var$app.ports.getCurrentUrl.subscribe(function() {
    $35da740d59af89ba$var$app.ports.receiveCurrentUrl.send(window.location.href);
});


//# sourceMappingURL=repo.28c95194.js.map
